import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Input from "../../comman/input";
import TextArea from "../../comman/textarea";
import auth from "../../services/authService";
import { getAlert } from "../../services/appAlerts";
import { uploadFileToBlob } from "../../services/blobUploadService";
import { updateTimeLogInvoice, uploadTimeLogInvoiceDocument } from "../../app/store/timeLogInvoice";

function UploadInvoice(props) {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [documents, setDocuments] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const fileInputRef = useRef(null);
  const dispatch = useDispatch();

  const validate = () => {
    const nextErrors = {};
    if (!String(data.invNumber || "").trim()) {
      nextErrors.invNumber = "Invoice Number is required";
    }
    if (documents.length === 0) {
      nextErrors.invoiceDocument = "Invoice document is required";
    }
    return Object.keys(nextErrors).length > 0 ? nextErrors : null;
  };

  const handleChange = ({ currentTarget: input }) => {
    setData((prev) => ({
      ...prev,
      [input.name]: input.value,
    }));

    if (errors[input.name]) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next[input.name];
        return next;
      });
    }
  };

  const renderInput = (name, label, type = "text") => (
    <Input
      type={type}
      name={name}
      value={data[name] || ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
      req={name === "invNumber"}
    />
  );

  const renderTextArea = (name, label) => (
    <TextArea
      name={name}
      value={data[name] || ""}
      label={label}
      onChange={handleChange}
      error={errors[name]}
    />
  );

  const doSubmit = async () => {
    const user = auth.getCurrentUser();
    const { wfTask: workflowTask, selectedObj, handleInvShowHide } = props;
    let docId = 0;

    if (documents.length > 0) {
      const frmData = new FormData();
      frmData.append("message", data["notes"] || "");
      frmData.append("workflowTask", JSON.stringify(workflowTask));
      frmData.append("userId", user.id);

      frmData.append(
        "files",
        JSON.stringify(
          documents.map((file) => {
            return {
              name: file.name,
              type: file.type,
              size: file.size,
            };
          })
        )
      );

      const result = await dispatch(uploadTimeLogInvoiceDocument(frmData));

      docId = result?.uploadId;

      if (docId > 0) {
        await Promise.all(
          documents.map((file, key) => {
            if (!file.file) return Promise.resolve();
            return uploadFileToBlob(
              file.file,
              result.sasUrls[key].uploadUrl,
              (progress) => {
                console.log(`Upload progress for ${file.name}: ${progress}%`);
              }
            );
          })
        );
      }
    }

    const tmObj = {
      id: selectedObj.id,
      invoiceDocId: docId,
      notes: data["notes"] || "",
      remarks: data["invNumber"] || "",
      docUploadType: "agency",
    };

    await dispatch(updateTimeLogInvoice(tmObj));
    handleInvShowHide("save");
    getAlert("Invoice Uploaded Successfully", "", "success");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isProcessing) return;
    const formErrors = validate();
    setErrors(formErrors || {});
    if (formErrors) return;
    setIsProcessing(true);
    try {
      await doSubmit();
    } catch (err) {
      console.error(err);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    const docs = [
      ...documents,
      ...droppedFiles.map((file) => ({
        name: file.name,
        type: file.type,
        file,
        size: file.size,
      })),
    ];
    setDocuments(docs);
    setErrors((prev) => {
      const next = { ...prev };
      delete next.invoiceDocument;
      return next;
    });
  };

  const onFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const docs = [
      ...documents,
      ...selectedFiles.map((file) => ({
        name: file.name,
        type: file.type,
        file,
        size: file.size,
      })),
    ];
    setDocuments(docs);
    setErrors((prev) => {
      const next = { ...prev };
      delete next.invoiceDocument;
      return next;
    });
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  const { invShowHide, handleInvShowHide } = props;

  const formatFileSize = (bytes) => {
    if (bytes === undefined || bytes === null) return "0 Bytes";
    if (bytes >= 1048576) {
      return `${(bytes / 1048576).toFixed(2)} MB`;
    }
    return `${(bytes / 1024).toFixed(1)} KB`;
  };

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: `
        /* Ensure the modal and backdrop are on top of other elements */
        .modal-backdrop {
          z-index: 1080 !important;
        }
        .modal {
          z-index: 1090 !important;
          overflow-y: hidden !important;
        }

        /* Glassmorphic backdrop filter and blur */
        .modal-backdrop.show {
          backdrop-filter: blur(8px) !important;
          -webkit-backdrop-filter: blur(8px) !important;
          background-color: rgba(15, 23, 42, 0.45) !important;
          opacity: 1 !important;
        }

        /* Spring-like transition for scale-in animation */
        .modal.fade .wf-pay-modal.modal-dialog {
          transform: scale(0.96) !important;
          transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
        }
        .modal.show .wf-pay-modal.modal-dialog {
          transform: scale(1) !important;
        }

        .wf-pay-modal {
          max-width: 680px !important;
          width: 100% !important;
          font-family: "Open Sans", sans-serif !important;
        }

        .wf-pay-modal .modal-content {
          border-radius: 0 !important;
          border: 1px solid #cbd5e1 !important;
          box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.25) !important;
          overflow: hidden !important;
          background: #ffffff !important;
        }

        .wf-pay-modal .modal-header {
          position: relative !important;
          display: block !important;
          padding: 14px 24px !important;
          background: #ffffff !important;
          border-bottom: 1px solid #edf2f7 !important;
          overflow: hidden !important;
        }

        .wf-pay-modal .modal-header::before {
          display: none !important;
        }

        .wf-pay-modal .rt-header-shell {
          display: flex !important;
          flex-direction: column !important;
          gap: 0 !important;
          width: 100% !important;
        }

        .wf-pay-modal .rt-header-top {
          display: flex !important;
          justify-content: space-between !important;
          align-items: center !important;
          gap: 16px !important;
          width: 100% !important;
        }

        .wf-pay-modal .rt-header-main {
          display: flex !important;
          align-items: center !important;
          gap: 14px !important;
          min-width: 0 !important;
          flex: 1 1 auto !important;
        }

        .wf-pay-modal .rt-header-copy {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
          min-width: 0 !important;
        }

        .wf-pay-modal .rt-modal-title {
          display: inline-flex !important;
          align-items: center !important;
          margin: 0 !important;
          color: #0f172a !important;
          font-size: 17px !important;
          font-weight: 600 !important;
          line-height: 1.25 !important;
        }

        .wf-pay-modal .rt-header-icon {
          width: 38px !important;
          height: 38px !important;
          min-height: 38px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #171717 !important;
          background: #f5f5f5 !important;
          border: 1px solid #d4d4d4 !important;
          box-shadow: 0 2px 5px rgba(15,23,42,0.06) !important;
          font-size: 16px !important;
          flex-shrink: 0 !important;
        }

        .wf-pay-modal .rt-modal-title-text {
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          flex-wrap: wrap !important;
        }

        .wf-pay-modal .rt-modal-title-badge {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          padding: 3px 8px !important;
          border-radius: 0 !important;
          font-size: 10px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.04em !important;
          background: #171717 !important;
          color: #ffffff !important;
          border: 1px solid #171717 !important;
        }

        .wf-pay-modal .rt-modal-desc {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          color: #64748b !important;
          font-weight: 500 !important;
          line-height: 1.4 !important;
          font-size: 12px !important;
        }
        .wf-pay-modal .rt-modal-desc i {
          color: #64748b !important;
        }

        .wf-pay-modal .rt-action-btn {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 32px !important;
          height: 32px !important;
          padding: 0 !important;
          font-size: 14px !important;
          color: #64748b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          outline: none !important;
        }
        .wf-pay-modal .rt-action-btn:hover {
          color: #ef4444 !important;
          border-color: #fca5a5 !important;
          background: #fef2f2 !important;
          transform: translateY(-1px) !important;
        }

        .wf-pay-modal .modal-body {
          padding: 24px !important;
          background: #ffffff !important;
          max-height: calc(90vh - 140px) !important;
          overflow-y: auto !important;
        }

        .wf-pay-modal .form-group {
          margin-bottom: 16px !important;
        }

        .wf-pay-modal label.form-control-label {
          display: block !important;
          font-size: 12px !important;
          font-weight: 600 !important;
          color: #334155 !important;
          margin-bottom: 6px !important;
          letter-spacing: 0.01em !important;
          text-transform: uppercase !important;
        }

        .wf-pay-modal .form-control {
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 8px 12px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #0f172a !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          outline: none !important;
        }

        .wf-pay-modal .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12) !important;
        }
        
        .wf-pay-modal .form-control::placeholder {
          color: #94a3b8 !important;
          font-weight: 400 !important;
        }

        .wf-pay-modal textarea.form-control {
          min-height: 72px !important;
          resize: vertical !important;
        }

        /* Dropzone Style */
        .wf-pay-modal .drop-zone {
          border: 1.5px dashed #cbd5e1 !important;
          border-radius: 0 !important;
          padding: 24px 16px !important;
          background: #f8fafc !important;
          cursor: pointer !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 8px !important;
        }
        .wf-pay-modal .drop-zone:hover {
          border-color: #2563eb !important;
          background: #eff6ff !important;
        }
        .wf-pay-modal .drop-zone.dragging {
          border-color: #2563eb !important;
          background: #eff6ff !important;
          transform: scale(1.005) !important;
        }
        .wf-pay-modal .drop-icon-wrapper {
          width: 40px !important;
          height: 40px !important;
          border-radius: 0 !important;
          background: #eff6ff !important;
          border: 1px solid #bfdbfe !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #2563eb !important;
          font-size: 17px !important;
          transition: all 0.2s ease !important;
        }
        .wf-pay-modal .drop-zone:hover .drop-icon-wrapper {
          background: #dbeafe !important;
          transform: translateY(-1px) !important;
        }
        .wf-pay-modal .drop-text-primary {
          font-size: 13.5px !important;
          font-weight: 600 !important;
          color: #1e293b !important;
        }
        .wf-pay-modal .drop-text-secondary {
          font-size: 11.5px !important;
          font-weight: 400 !important;
          color: #64748b !important;
        }

        /* File Previews */
        .wf-pay-modal .file-preview {
          margin-top: 12px !important;
          display: flex !important;
          flex-direction: column !important;
          gap: 8px !important;
        }
        .wf-pay-modal .file-preview-item {
          display: flex !important;
          align-items: center !important;
          justify-content: space-between !important;
          padding: 10px 14px !important;
          background: #ffffff !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 0 !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
        }
        .wf-pay-modal .file-preview-item:hover {
          border-color: #cbd5e1 !important;
          background: #f8fafc !important;
        }
        .wf-pay-modal .file-info {
          display: flex !important;
          align-items: center !important;
          gap: 10px !important;
          min-width: 0 !important;
        }
        .wf-pay-modal .file-icon {
          font-size: 16px !important;
          color: #ef4444 !important;
        }
        .wf-pay-modal .file-details {
          display: flex !important;
          flex-direction: column !important;
          gap: 1px !important;
          min-width: 0 !important;
        }
        .wf-pay-modal .file-name {
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #0f172a !important;
          white-space: nowrap !important;
          overflow: hidden !important;
          text-overflow: ellipsis !important;
        }
        .wf-pay-modal .file-size {
          font-size: 11px !important;
          font-weight: 500 !important;
          color: #64748b !important;
        }
        .wf-pay-modal .file-remove-btn {
          width: 28px !important;
          height: 28px !important;
          border-radius: 0 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #94a3b8 !important;
          background: transparent !important;
          border: 1px solid transparent !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }
        .wf-pay-modal .file-remove-btn:hover {
          color: #ef4444 !important;
          background: #fef2f2 !important;
          border-color: #fecdd3 !important;
        }

        .wf-pay-modal .modal-footer {
          background: #f8fafc !important;
          border-top: 1px solid #edf2f7 !important;
          padding: 14px 24px !important;
          display: flex !important;
          justify-content: flex-end !important;
          gap: 10px !important;
        }

        .wf-modal-footer-close-btn {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 7px 14px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          border-radius: 0 !important;
          box-shadow: 0 2px 5px rgba(15, 23, 42, 0.06) !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
        }
        .wf-modal-footer-close-btn:hover {
          background: #f8fafc !important;
          color: #0f172a !important;
          border-color: #94a3b8 !important;
          box-shadow: 0 3px 8px rgba(15, 23, 42, 0.1) !important;
        }

        .wf-pay-modal .wf-btn-save {
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 7px !important;
          padding: 7px 16px !important;
          border-radius: 0 !important;
          border: 1px solid #2563eb !important;
          background: #2563eb !important;
          color: #ffffff !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          outline: none !important;
          box-shadow: 0 2px 5px rgba(37, 99, 235, 0.2) !important;
        }
        .wf-pay-modal .wf-btn-save:hover {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 3px 8px rgba(37, 99, 235, 0.28) !important;
        }
        .wf-pay-modal .wf-btn-save:active {
          transform: scale(0.97) !important;
        }
        .wf-pay-modal .wf-btn-save:disabled {
          background: #cbd5e1 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
          transform: none !important;
        }
` }} />
      <Modal show={invShowHide} size="lg" dialogClassName="wf-pay-modal" centered>
        <Modal.Header>
          <div className="rt-header-shell">
            <div className="rt-header-top">
              <div className="rt-header-main">
                <i className="rt-header-icon fa fa-file-text-o" aria-hidden="true" />
                <div className="rt-header-copy">
                  <h2 className="rt-modal-title">
                    <span className="rt-modal-title-text">
                      <span>Upload Invoice</span>
                      <span className="rt-modal-title-badge">Invoice</span>
                    </span>
                  </h2>
                  <span className="rt-modal-desc">
                    <i className="fa fa-info-circle" aria-hidden="true" /> Enter invoice details, upload your file, and add notes.
                  </span>
                </div>
              </div>
              <button
                type="button"
                className="rt-action-btn"
                onClick={() => handleInvShowHide("")}
                title="Close"
              >
                <i className="fa fa-times" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="border-0">
          <div className="row">
            <div className="col-md-12">{renderInput("invNumber", "Invoice Number")}</div>

            <div className="col-md-12 form-group required">
              <label className="form-control-label">Upload Invoice File</label>
              <div
                className={`drop-zone ${isDragging ? "dragging" : ""}`}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
                onClick={() => fileInputRef.current && fileInputRef.current.click()}
              >
                <div className="drop-icon-wrapper">
                  <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                </div>
                <span className="drop-text-primary">
                  {isDragging ? "Drop files here..." : "Drag & drop invoice here, or click to select"}
                </span>
                <span className="drop-text-secondary">
                  Supports PDF, DOCX, PNG, JPG up to 10MB
                </span>
                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={onFileChange}
                  multiple
                  hidden
                />
              </div>
              {errors.invoiceDocument && (
                <span className="text-danger d-block mt-2">{errors.invoiceDocument}</span>
              )}

              {documents.length > 0 && (
                <div className="file-preview">
                  {documents.map((file, index) => (
                    <div key={index} className="file-preview-item">
                      <div className="file-info">
                        <i className="fa fa-file-pdf-o file-icon" aria-hidden="true" />
                        <div className="file-details">
                          <span className="file-name">{file.name}</span>
                          <span className="file-size">{formatFileSize(file.size)}</span>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="file-remove-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleFileRemove(file);
                        }}
                        title="Remove file"
                      >
                        <i className="fa fa-trash-o" aria-hidden="true"></i>
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="col-md-12">{renderTextArea("notes", "Notes")}</div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="wf-modal-footer-close-btn"
            onClick={() => handleInvShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </button>
          <button
            className="wf-btn-save"
            onClick={handleSubmit}
            disabled={
              isProcessing ||
              !String(data.invNumber || "").trim() ||
              documents.length === 0
            }
          >
            <i
              className={`fa ${isProcessing ? "fa-spinner fa-spin" : "fa-paper-plane"}`}
              aria-hidden="true"
            ></i>{" "}
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default UploadInvoice;
